module.exports = {"350121001":"甘蔗街道","350121101":"白沙镇","350121102":"南屿镇","350121103":"尚干镇","350121104":"祥谦镇","350121105":"青口镇","350121106":"南通镇","350121107":"上街镇","350121108":"荆溪镇","350121200":"竹岐乡","350121201":"鸿尾乡","350121202":"洋里乡","350121203":"大湖乡","350121204":"廷坪乡","350121206":"小箬乡","350121400":"江洋农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350121.json
// module id = 1275
// module chunks = 0